<template>
		<div class="content" v-if="!notFound">
      <Header></Header>
      <div class="nav">
      	<span class="">{{$t('invitation_log')}}</span>
      </div>
      <div class=" personal-info">
        <div class="myPoints-list">
          <div class="point-history mt20">
            <div class="point-head ac disflex">
              <span class="point-one2">{{$t('phone')}}</span>
              <span class="point-one1">{{$t('Date')}}</span>
            </div>
            <div class="point-c app-en" v-for="(item,index) in list">
              <div class="point-li ac disflex">
                <span class="point-one2">{{item.invited_mobile}}</span>
                <span class="point-one1">{{item.created_time}}</span>
              </div>
            </div>
          </div>
          <!-- <div class="more mt50 ac crfff" v-if="isShow" ><button  @click="getMore" class="btn1">{{noMore}}</button></div>
          <div class="more mt50 ac crfff"  v-else ><button @click="getMore" class="btn1">{{$t('noMore')}}</button></div> -->
        </div>
      </div>
		</div>
</template>
<script>
import Header from '../components/header'
export default {
    components:{
		Header
    },
    data() {

    return {
			notFound:false,
			list:[],
			page:1,
			limit:5,
      score:'',
			isShow:true,
      listMenu:['All','action','adventure','puzzle','sports'],
      noMore:''
		}
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){
		this.getHome();
	},
    methods: {
		back(){
			this.$router.push({path:'/'})
		},
		getHome(){
			let that =this;
      this.$parent.loadModal(true);
			let data = {
				page:that.page,
				//limit:that.limit,
			}
      this.noMore = that.$t('showMore')
			that.$api.post('/api/index/invitation_log',data,r =>{
				that.$parent.returnCode(r,function(){
					that.$parent.loadModal(false);
          console.log(r)
					if(r.data.length>0){
						that.list = that.list.concat(r.data)
            console.log(that.list)
					}else{
						that.isShow = false;
            //that.noMore = that.$t('noMore')
						that.$utils.alertText(that.$t('noMore'));
					}

       });

			})
		},
		getMore(){
			let that = this;
			if(that.isShow){
				that.page++;
				that.getHome();
			}else{
				that.$utils.alertText(that.$t('noMore'));
			}
		},
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/invitationLog.vue